import axios from "axios";
import config from "../../../config";

function authHeaders(token) {
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
}

export function fetchCustomerPortalCheckoutContext(token, lines, editAppointmentId = null) {
  const body = { lines };
  if (editAppointmentId) {
    body.edit_appointment_id = editAppointmentId;
  }
  return axios.post(`${config.API_URL}customer-portal/booking/checkout-context`, body, {
    headers: authHeaders(token),
  });
}

export function storeCustomerPortalBooking(token, payload) {
  return axios.post(`${config.API_URL}customer-portal/booking/store`, payload, {
    headers: authHeaders(token),
  });
}

export function confirmCustomerPortalBookingPayment(token, payload) {
  return axios.post(`${config.API_URL}customer-portal/booking/confirm-payment`, payload, {
    headers: authHeaders(token),
  });
}

export function validateCustomerPortalVoucher(token, { code, services_id }) {
  return axios.post(
    `${config.API_URL}customer-portal/booking/validate-voucher`,
    { code, services_id },
    { headers: authHeaders(token) }
  );
}
